import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

const StudentProgressTrophiesWidget = observer((props = {}) => {
  const { onlyRenderInnerWidgetContent, t } = props;

  const { studentProgressManager } = useContext(MobXProviderContext);
  const { trophyCounts } = studentProgressManager;
  const trophyTiers = studentProgressManager.getActiveTrophyTiers();

  const Trophy = SatCoreComponent('Trophy');

  const trophiesLabel = t('TrophiesLabel', 'Missing trophies label translation');

  const innerWidgetContent = (
    <div className='trophy-content'>
      {trophyTiers.map((tier, index) => (
        <React.Fragment key={tier.id}>
          {index > 0 && <div className='trophy-spacer' />}
          <Trophy count={trophyCounts[tier.id] ?? 0} tier={tier} />
        </React.Fragment>
      ))}
    </div>
  );

  return !onlyRenderInnerWidgetContent ? (
    <div className='StudentProgressTrophiesWidget StudentProgressWidget widget trophies-widget' tabIndex='0'>
      <h2 aria-label={`${trophiesLabel}:`} className='w-title'>{trophiesLabel}</h2>
      {innerWidgetContent}
    </div>
  ) : innerWidgetContent;
});

export default StudentProgressTrophiesWidget;

SatCoreRegister('StudentProgressTrophiesWidget', StudentProgressTrophiesWidget);
